import { Filters } from '@terminal/components/filters/Filters';
import {
  FilterState,
  PerformanceFilterGroupKeys,
} from '@terminal/hooks/use-filter-actions/useFilterActions';
import { POSTHOG_TRACKING_SOURCES } from '@terminal/services/tracking/posthog/constants';
import { ResetAllButton } from '@terminal/views/screener/reset-all-button/ResetAllButton';
import { RANK_FILTERS_KEY } from '@terminal/views/screener/use-screener-store/filter-utils';
import { useTranslation } from 'react-i18next';

import { TOP10_FILTER_KEY } from '../filter-utils';
import { usePerformanceStore } from '../hooks/usePerformanceStore';
import styles from './PerformanceFilters.module.scss';

export const PerformanceFilters = () => {
  const { t } = useTranslation(['screener']);
  const { filterGroups, clearAllActiveFilterOptions } = usePerformanceStore(
    state => ({
      filterGroups: state.filterGroups,
      clearAllActiveFilterOptions: state.clearAllActiveFilterOptions,
    })
  );

  const hasActiveFiltersOptions = Object.entries(filterGroups).some(
    ([key, val]) => {
      if (key === 'THEME_PERF_FILTERS') {
        const rankFilterOption = val.activeFilterOptions.find(
          f => f.filter === RANK_FILTERS_KEY
        );
        return (
          !!rankFilterOption &&
          !rankFilterOption.options.map(f => f.key).includes(TOP10_FILTER_KEY)
        );
      } else {
        return val.activeFilterOptions.length > 0;
      }
    }
  );

  return (
    <div className={styles.filtersWrapper}>
      {Object.entries<FilterState>(filterGroups).map(([group, filterState]) => {
        return (
          filterState.allFilters && (
            <Filters
              key={group}
              filterState={filterState}
              store={usePerformanceStore}
              group={group as PerformanceFilterGroupKeys}
              showAddMoreFilters={false}
              source={POSTHOG_TRACKING_SOURCES.THEME_OVERVIEW}
            />
          )
        );
      })}
      {hasActiveFiltersOptions && (
        <div className={styles.resetAllButtonWrapper}>
          <ResetAllButton
            resetActiveFilterOptions={() => clearAllActiveFilterOptions(t)}
          />
        </div>
      )}
    </div>
  );
};
